/**
 * @generated SignedSource<<e90ac9e37a57334b64c5311af834ba4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgentConnectedDialog_organization$data = {
  readonly agents?: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
      } | null;
    } | null> | null;
  } | null;
  readonly clusters?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly queues: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly key: string;
              readonly stackHealth: string | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly slug: string;
  readonly " $fragmentType": "AgentConnectedDialog_organization";
};
export type AgentConnectedDialog_organization$key = {
  readonly " $data"?: AgentConnectedDialog_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"AgentConnectedDialog_organization">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 1
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isMounted"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgentConnectedDialog_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "condition": "isMounted",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": (v0/*: any*/),
          "concreteType": "AgentConnection",
          "kind": "LinkedField",
          "name": "agents",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AgentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Agent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "agents(last:1)"
        },
        {
          "alias": null,
          "args": (v0/*: any*/),
          "concreteType": "ClusterConnection",
          "kind": "LinkedField",
          "name": "clusters",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ClusterEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Cluster",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": (v0/*: any*/),
                      "concreteType": "ClusterQueueConnection",
                      "kind": "LinkedField",
                      "name": "queues",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ClusterQueueEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ClusterQueue",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "key",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "stackHealth",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "queues(last:1)"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "clusters(last:1)"
        }
      ]
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "5d9e552dd7ded47c09a066dc1a5654e6";

export default node;
